module.exports = __webpack_public_path__ + "static/media/best-burger-ever-burger-mobile-fr.db98887e.jpg";